export function artistbutton_mouseIn(event) {
    $w("#megamenu").show();
}

export function artistbutton_mouseOut(event) {
    

}

export function megamenu_mouseIn(event) {
    $w("#megamenu").show();
}


export function megamenu_mouseOut(event) {
	$w("#megamenu").hide();
}